import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import Chip from '@material-ui/core/Chip'
import toastError from '../../errors/toastError'
import api from '../../services/api'
import { i18n } from '../../translate/i18n'

const useStyles = makeStyles(theme => ({
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
}))

const QueueSelect = ({ selectedQueueIds, onChange, multiple = true, title = i18n.t('queueSelect.inputLabel') }) => {
  const classes = useStyles()
  const [queues, setQueues] = useState([])
  const normalizedValue = multiple ? selectedQueueIds || [] : selectedQueueIds || ''

  useEffect(() => {
    fetchQueues()
  }, [])

  const fetchQueues = async () => {
    try {
      const { data } = await api.get('/queue')
      setQueues(data)
    } catch (err) {
      toastError(err)
    }
  }

  const handleChange = e => {
    onChange(multiple ? e.target.value : e.target.value || null)
  }

  return (
    <div>
      <FormControl fullWidth margin='dense' variant='outlined'>
        <InputLabel shrink={multiple ? normalizedValue.length > 0 : Boolean(normalizedValue)}>{title}</InputLabel>
        <Select
          label={title}
          multiple={multiple}
          labelWidth={60}
          value={normalizedValue}
          onChange={handleChange}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            getContentAnchorEl: null,
          }}
          renderValue={selected => {
            if (!multiple && !selected) {
              return ''
            }

            return (
              <div className={classes.chips}>
                {selected?.length > 0 && multiple ? (
                  selected.map(id => {
                    const queue = queues.find(q => q.id === id)
                    return queue ? <Chip key={id} style={{ backgroundColor: queue.color }} variant='outlined' label={<span translate='no'>{queue.name}</span>} className={classes.chip} /> : null
                  })
                ) : (
                  <Chip
                    key={selected}
                    variant='outlined'
                    style={{ backgroundColor: queues.find(q => q.id === selected)?.color }}
                    label={<span translate='no'>{queues.find(q => q.id === selected)?.name || ''}</span>}
                    className={classes.chip}
                  />
                )}
              </div>
            )
          }}
        >
          {!multiple && <MenuItem value=''>Nenhum</MenuItem>}
          {queues.map(queue => (
            <MenuItem key={queue.id} value={queue.id} translate='no' className='notranslate'>
              <span translate='no'>{queue.name}</span>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}

export default QueueSelect
